// extracted by mini-css-extract-plugin
export default {"container":"LiveBadge_container__YTYD4","onair":"LiveBadge_onair__bLimf","onair_wave":"LiveBadge_onair_wave__O7++c"};